module.exports = __webpack_public_path__ + "img/he.8d43b0f0.svg";